export const distribution_parenthood = [
  {
    id: 1,
    label: 0,
    score: 0.481957224566747,
    data_type: "random",
  },
  {
    id: 2,
    label: 0,
    score: 0.41121649778757,
    data_type: "random",
  },
  {
    id: 3,
    label: 0,
    score: 0.40971240625382,
    data_type: "random",
  },
  {
    id: 4,
    label: 0,
    score: 0.532241997700791,
    data_type: "random",
  },
  {
    id: 5,
    label: 0,
    score: 0.342511081317506,
    data_type: "random",
  },
  {
    id: 6,
    label: 0,
    score: 0.271144210957955,
    data_type: "random",
  },
  {
    id: 7,
    label: 0,
    score: 0.315154647048808,
    data_type: "random",
  },
  {
    id: 8,
    label: 0,
    score: 0.336073010142994,
    data_type: "random",
  },
  {
    id: 9,
    label: 0,
    score: 0.403976757069022,
    data_type: "random",
  },
  {
    id: 10,
    label: 0,
    score: 0.391652676604169,
    data_type: "random",
  },
  {
    id: 11,
    label: 0,
    score: 0.295491836608861,
    data_type: "random",
  },
  {
    id: 12,
    label: 0,
    score: 0.21533797440897,
    data_type: "random",
  },
  {
    id: 13,
    label: 0,
    score: 0.388159161279215,
    data_type: "random",
  },
  {
    id: 14,
    label: 0,
    score: 0.373355928340355,
    data_type: "random",
  },
  {
    id: 15,
    label: 0,
    score: 0.5053975230595,
    data_type: "random",
  },
  {
    id: 16,
    label: 0,
    score: 0.579437791842982,
    data_type: "random",
  },
  {
    id: 17,
    label: 0,
    score: 0.428099316294745,
    data_type: "random",
  },
  {
    id: 18,
    label: 0,
    score: 0.617530378477621,
    data_type: "random",
  },
  {
    id: 19,
    label: 0,
    score: 0.303861837532761,
    data_type: "random",
  },
  {
    id: 20,
    label: 0,
    score: 0.342283331708414,
    data_type: "random",
  },
  {
    id: 21,
    label: 0,
    score: 0.247470743083083,
    data_type: "random",
  },
  {
    id: 22,
    label: 0,
    score: 0.505533046761948,
    data_type: "random",
  },
  {
    id: 23,
    label: 0,
    score: 0.258095325160124,
    data_type: "random",
  },
  {
    id: 24,
    label: 0,
    score: 0.365223006111602,
    data_type: "random",
  },
  {
    id: 25,
    label: 0,
    score: 0.387912985788489,
    data_type: "random",
  },
  {
    id: 26,
    label: 0,
    score: 0.286810176635596,
    data_type: "random",
  },
  {
    id: 27,
    label: 0,
    score: 0.576583420156431,
    data_type: "random",
  },
  {
    id: 28,
    label: 0,
    score: 0.298407929692754,
    data_type: "random",
  },
  {
    id: 29,
    label: 0,
    score: 0.573521909303964,
    data_type: "random",
  },
  {
    id: 30,
    label: 0,
    score: 0.781145917439785,
    data_type: "random",
  },
  {
    id: 31,
    label: 0,
    score: 0.530237542262269,
    data_type: "random",
  },
  {
    id: 32,
    label: 0,
    score: 0.57173167090012,
    data_type: "random",
  },
  {
    id: 33,
    label: 0,
    score: 0.459800913917905,
    data_type: "random",
  },
  {
    id: 34,
    label: 0,
    score: 0.590800704821194,
    data_type: "random",
  },
  {
    id: 35,
    label: 0,
    score: 0.481197191073327,
    data_type: "random",
  },
  {
    id: 36,
    label: 0,
    score: 0.785628413690069,
    data_type: "random",
  },
  {
    id: 37,
    label: 0,
    score: 0.518225630203101,
    data_type: "random",
  },
  {
    id: 38,
    label: 0,
    score: 0.357413938026342,
    data_type: "random",
  },
  {
    id: 39,
    label: 0,
    score: 0.413159703147161,
    data_type: "random",
  },
  {
    id: 40,
    label: 0,
    score: 0.580756024262897,
    data_type: "random",
  },
  {
    id: 41,
    label: 0,
    score: 0.326690723531189,
    data_type: "random",
  },
  {
    id: 42,
    label: 0,
    score: 0.594606626072778,
    data_type: "random",
  },
  {
    id: 43,
    label: 0,
    score: 0.387658917762139,
    data_type: "random",
  },
  {
    id: 44,
    label: 0,
    score: 0.625470353263052,
    data_type: "random",
  },
  {
    id: 45,
    label: 0,
    score: 0.419644752993926,
    data_type: "random",
  },
  {
    id: 46,
    label: 0,
    score: 0.328340462960245,
    data_type: "random",
  },
  {
    id: 47,
    label: 0,
    score: 0.369349165997267,
    data_type: "random",
  },
  {
    id: 48,
    label: 0,
    score: 0.375207164625638,
    data_type: "random",
  },
  {
    id: 49,
    label: 0,
    score: 0.38743386220061,
    data_type: "random",
  },
  {
    id: 50,
    label: 0,
    score: 0.410625681188608,
    data_type: "random",
  },
  {
    id: 51,
    label: 0,
    score: 0.404362229402158,
    data_type: "random",
  },
  {
    id: 52,
    label: 0,
    score: 0.438209403308917,
    data_type: "random",
  },
  {
    id: 53,
    label: 0,
    score: 0.271950817944009,
    data_type: "random",
  },
  {
    id: 54,
    label: 0,
    score: 0.205996910937528,
    data_type: "random",
  },
  {
    id: 55,
    label: 0,
    score: 0.438698868886622,
    data_type: "random",
  },
  {
    id: 56,
    label: 0,
    score: 0.363712087544794,
    data_type: "random",
  },
  {
    id: 57,
    label: 0,
    score: 0.345777358691088,
    data_type: "random",
  },
  {
    id: 58,
    label: 0,
    score: 0.338314247331573,
    data_type: "random",
  },
  {
    id: 59,
    label: 0,
    score: 0.259116925452177,
    data_type: "random",
  },
  {
    id: 60,
    label: 0,
    score: 0.497187895839319,
    data_type: "random",
  },
  {
    id: 61,
    label: 0,
    score: 0.630827943026221,
    data_type: "random",
  },
  {
    id: 62,
    label: 0,
    score: 0.446995629347558,
    data_type: "random",
  },
  {
    id: 63,
    label: 0,
    score: 0.433059112857856,
    data_type: "random",
  },
  {
    id: 64,
    label: 0,
    score: 0.28055294475938,
    data_type: "random",
  },
  {
    id: 65,
    label: 0,
    score: 0.252916879466263,
    data_type: "random",
  },
  {
    id: 66,
    label: 0,
    score: 0.440446304857822,
    data_type: "random",
  },
  {
    id: 67,
    label: 0,
    score: 0.540283862226668,
    data_type: "random",
  },
  {
    id: 68,
    label: 0,
    score: 0.666683938824444,
    data_type: "random",
  },
  {
    id: 69,
    label: 0,
    score: 0.583578556118708,
    data_type: "random",
  },
  {
    id: 70,
    label: 0,
    score: 0.218046806126641,
    data_type: "random",
  },
  {
    id: 71,
    label: 0,
    score: 0.414636079627385,
    data_type: "random",
  },
  {
    id: 72,
    label: 0,
    score: 0.315833251442734,
    data_type: "random",
  },
  {
    id: 73,
    label: 0,
    score: 0.573130656941268,
    data_type: "random",
  },
  {
    id: 74,
    label: 0,
    score: 0.469788341093324,
    data_type: "random",
  },
  {
    id: 75,
    label: 0,
    score: 0.391725191366215,
    data_type: "random",
  },
  {
    id: 76,
    label: 0,
    score: 0.259967881576426,
    data_type: "random",
  },
  {
    id: 77,
    label: 0,
    score: 0.418682360414141,
    data_type: "random",
  },
  {
    id: 78,
    label: 0,
    score: 0.39077061964943,
    data_type: "random",
  },
  {
    id: 79,
    label: 0,
    score: 0.67106668085343,
    data_type: "random",
  },
  {
    id: 80,
    label: 0,
    score: 0.58367524520255,
    data_type: "random",
  },
  {
    id: 81,
    label: 0,
    score: 0.565020649050883,
    data_type: "random",
  },
  {
    id: 82,
    label: 0,
    score: 0.520649191837903,
    data_type: "random",
  },
  {
    id: 83,
    label: 0,
    score: 0.403894421784365,
    data_type: "random",
  },
  {
    id: 84,
    label: 0,
    score: 0.661190489327267,
    data_type: "random",
  },
  {
    id: 85,
    label: 0,
    score: 0.183015793779629,
    data_type: "random",
  },
  {
    id: 86,
    label: 0,
    score: 0.415446409708716,
    data_type: "random",
  },
  {
    id: 87,
    label: 0,
    score: 0.66217666283683,
    data_type: "random",
  },
  {
    id: 88,
    label: 0,
    score: 0.592384534625627,
    data_type: "random",
  },
  {
    id: 89,
    label: 0,
    score: 0.751619154500469,
    data_type: "random",
  },
  {
    id: 90,
    label: 0,
    score: 0.5846550703502,
    data_type: "random",
  },
  {
    id: 91,
    label: 0,
    score: 0.353784063037504,
    data_type: "random",
  },
  {
    id: 92,
    label: 0,
    score: 0.21967673372026,
    data_type: "random",
  },
  {
    id: 93,
    label: 0,
    score: 0.579427501592635,
    data_type: "random",
  },
  {
    id: 94,
    label: 0,
    score: 0.363462197487927,
    data_type: "random",
  },
  {
    id: 95,
    label: 0,
    score: 0.396606179670606,
    data_type: "random",
  },
  {
    id: 96,
    label: 0,
    score: 0.667412237411909,
    data_type: "random",
  },
  {
    id: 97,
    label: 0,
    score: 0.552187474746112,
    data_type: "random",
  },
  {
    id: 98,
    label: 0,
    score: 0.249825863940578,
    data_type: "random",
  },
  {
    id: 99,
    label: 0,
    score: 0.479781962382436,
    data_type: "random",
  },
  {
    id: 100,
    label: 0,
    score: 0.494617152089921,
    data_type: "random",
  },
  {
    id: 101,
    label: 0,
    score: 0.663775097345803,
    data_type: "random",
  },
  {
    id: 102,
    label: 0,
    score: 0.455453567964195,
    data_type: "random",
  },
  {
    id: 103,
    label: 0,
    score: 0.228454471452982,
    data_type: "random",
  },
  {
    id: 104,
    label: 0,
    score: 0.214189189453398,
    data_type: "random",
  },
  {
    id: 105,
    label: 0,
    score: 0.307494581809653,
    data_type: "random",
  },
  {
    id: 106,
    label: 0,
    score: 0.515464180816008,
    data_type: "random",
  },
  {
    id: 107,
    label: 0,
    score: 0.616944906557644,
    data_type: "random",
  },
  {
    id: 108,
    label: 0,
    score: 0.629325172665958,
    data_type: "random",
  },
  {
    id: 109,
    label: 0,
    score: 0.277038099004075,
    data_type: "random",
  },
  {
    id: 110,
    label: 0,
    score: 0.524247134320564,
    data_type: "random",
  },
  {
    id: 111,
    label: 0,
    score: 0.685483299768044,
    data_type: "random",
  },
  {
    id: 112,
    label: 0,
    score: 0.301076171140421,
    data_type: "random",
  },
  {
    id: 113,
    label: 0,
    score: 0.384117786388449,
    data_type: "random",
  },
  {
    id: 114,
    label: 0,
    score: 0.419585821390579,
    data_type: "random",
  },
  {
    id: 115,
    label: 0,
    score: 0.568683173313127,
    data_type: "random",
  },
  {
    id: 116,
    label: 0,
    score: 0.736221300527028,
    data_type: "random",
  },
  {
    id: 117,
    label: 0,
    score: 0.505265410804791,
    data_type: "random",
  },
  {
    id: 118,
    label: 0,
    score: 0.806095941714069,
    data_type: "random",
  },
  {
    id: 119,
    label: 0,
    score: 0.655901875699391,
    data_type: "random",
  },
  {
    id: 120,
    label: 0,
    score: 0.201435724691782,
    data_type: "random",
  },
  {
    id: 121,
    label: 0,
    score: 0.381767539473646,
    data_type: "random",
  },
  {
    id: 122,
    label: 0,
    score: 0.490559744646711,
    data_type: "random",
  },
  {
    id: 123,
    label: 0,
    score: 0.46498319973405,
    data_type: "random",
  },
  {
    id: 124,
    label: 0,
    score: 0.425212197435305,
    data_type: "random",
  },
  {
    id: 125,
    label: 0,
    score: 0.72883277748114,
    data_type: "random",
  },
  {
    id: 126,
    label: 0,
    score: 0.362196256303503,
    data_type: "random",
  },
  {
    id: 127,
    label: 0,
    score: 0.457461074383048,
    data_type: "random",
  },
  {
    id: 128,
    label: 0,
    score: 0.694047722115461,
    data_type: "random",
  },
  {
    id: 129,
    label: 0,
    score: 0.39361644117754,
    data_type: "random",
  },
  {
    id: 130,
    label: 0,
    score: 0.250508532456949,
    data_type: "random",
  },
  {
    id: 131,
    label: 0,
    score: 0.665940658924257,
    data_type: "random",
  },
  {
    id: 132,
    label: 0,
    score: 0.524475327339412,
    data_type: "random",
  },
  {
    id: 133,
    label: 0,
    score: 0.24081829507582,
    data_type: "random",
  },
  {
    id: 134,
    label: 0,
    score: 0.310317496830532,
    data_type: "random",
  },
  {
    id: 135,
    label: 0,
    score: 0.703781634778915,
    data_type: "random",
  },
  {
    id: 136,
    label: 0,
    score: 0.624353875629097,
    data_type: "random",
  },
  {
    id: 137,
    label: 0,
    score: 0.266227956361694,
    data_type: "random",
  },
  {
    id: 138,
    label: 0,
    score: 0.360095076855915,
    data_type: "random",
  },
  {
    id: 139,
    label: 0,
    score: 0.63121816566912,
    data_type: "random",
  },
  {
    id: 140,
    label: 0,
    score: 0.512851376620096,
    data_type: "random",
  },
  {
    id: 141,
    label: 0,
    score: 0.307218772940763,
    data_type: "random",
  },
  {
    id: 142,
    label: 0,
    score: 0.717881614049541,
    data_type: "random",
  },
  {
    id: 143,
    label: 0,
    score: 0.315566562336074,
    data_type: "random",
  },
  {
    id: 144,
    label: 0,
    score: 0.779201504094237,
    data_type: "random",
  },
  {
    id: 145,
    label: 0,
    score: 0.443278292445155,
    data_type: "random",
  },
  {
    id: 146,
    label: 0,
    score: 0.411053117091882,
    data_type: "random",
  },
  {
    id: 147,
    label: 0,
    score: 0.790496330592763,
    data_type: "random",
  },
  {
    id: 148,
    label: 0,
    score: 0.334162136266105,
    data_type: "random",
  },
  {
    id: 149,
    label: 0,
    score: 0.237495124989004,
    data_type: "random",
  },
  {
    id: 150,
    label: 0,
    score: 0.75652836802911,
    data_type: "random",
  },
  {
    id: 151,
    label: 0,
    score: 0.238505212054596,
    data_type: "random",
  },
  {
    id: 152,
    label: 0,
    score: 0.249138992252738,
    data_type: "random",
  },
  {
    id: 153,
    label: 0,
    score: 0.282138916799524,
    data_type: "random",
  },
  {
    id: 154,
    label: 0,
    score: 0.288981275281716,
    data_type: "random",
  },
  {
    id: 155,
    label: 0,
    score: 0.464968930845038,
    data_type: "random",
  },
  {
    id: 156,
    label: 0,
    score: 0.552120910301937,
    data_type: "random",
  },
  {
    id: 157,
    label: 0,
    score: 0.564470137521593,
    data_type: "random",
  },
  {
    id: 158,
    label: 0,
    score: 0.305830521095501,
    data_type: "random",
  },
  {
    id: 159,
    label: 0,
    score: 0.333651018629685,
    data_type: "random",
  },
  {
    id: 160,
    label: 0,
    score: 0.381708115174341,
    data_type: "random",
  },
  {
    id: 161,
    label: 0,
    score: 0.234878031701179,
    data_type: "random",
  },
  {
    id: 162,
    label: 0,
    score: 0.367463881341418,
    data_type: "random",
  },
  {
    id: 163,
    label: 0,
    score: 0.374706219981967,
    data_type: "random",
  },
  {
    id: 164,
    label: 0,
    score: 0.542322051951622,
    data_type: "random",
  },
  {
    id: 165,
    label: 0,
    score: 0.355213038994455,
    data_type: "random",
  },
  {
    id: 166,
    label: 0,
    score: 0.288756752899944,
    data_type: "random",
  },
  {
    id: 167,
    label: 0,
    score: 0.319560752735044,
    data_type: "random",
  },
  {
    id: 168,
    label: 0,
    score: 0.468477836475814,
    data_type: "random",
  },
  {
    id: 169,
    label: 0,
    score: 0.65473135180471,
    data_type: "random",
  },
  {
    id: 170,
    label: 0,
    score: 0.569610193464561,
    data_type: "random",
  },
  {
    id: 171,
    label: 0,
    score: 0.479908598801174,
    data_type: "random",
  },
  {
    id: 172,
    label: 0,
    score: 0.330223746254479,
    data_type: "random",
  },
  {
    id: 173,
    label: 0,
    score: 0.494752453060014,
    data_type: "random",
  },
  {
    id: 174,
    label: 0,
    score: 0.456000843837827,
    data_type: "random",
  },
  {
    id: 175,
    label: 0,
    score: 0.388649939263777,
    data_type: "random",
  },
  {
    id: 176,
    label: 0,
    score: 0.39222113283115,
    data_type: "random",
  },
  {
    id: 177,
    label: 0,
    score: 0.603667079848772,
    data_type: "random",
  },
  {
    id: 178,
    label: 0,
    score: 0.776725758745824,
    data_type: "random",
  },
  {
    id: 179,
    label: 0,
    score: 0.400355378255222,
    data_type: "random",
  },
  {
    id: 180,
    label: 0,
    score: 0.51218092130356,
    data_type: "random",
  },
  {
    id: 181,
    label: 0,
    score: 0.508459531892167,
    data_type: "random",
  },
  {
    id: 182,
    label: 0,
    score: 0.271030127241692,
    data_type: "random",
  },
  {
    id: 183,
    label: 0,
    score: 0.61188904635998,
    data_type: "random",
  },
  {
    id: 184,
    label: 0,
    score: 0.327788871825836,
    data_type: "random",
  },
  {
    id: 185,
    label: 0,
    score: 0.518484442550465,
    data_type: "random",
  },
  {
    id: 186,
    label: 0,
    score: 0.233917167830907,
    data_type: "random",
  },
  {
    id: 187,
    label: 0,
    score: 0.619894285538298,
    data_type: "random",
  },
  {
    id: 188,
    label: 0,
    score: 0.359718047651617,
    data_type: "random",
  },
  {
    id: 189,
    label: 0,
    score: 0.504256635141358,
    data_type: "random",
  },
  {
    id: 190,
    label: 0,
    score: 0.461252666988521,
    data_type: "random",
  },
  {
    id: 191,
    label: 0,
    score: 0.615639572533063,
    data_type: "random",
  },
  {
    id: 192,
    label: 0,
    score: 0.548890981449283,
    data_type: "random",
  },
  {
    id: 193,
    label: 0,
    score: 0.283590742366657,
    data_type: "random",
  },
  {
    id: 194,
    label: 0,
    score: 0.546343826077664,
    data_type: "random",
  },
  {
    id: 195,
    label: 0,
    score: 0.801542525690966,
    data_type: "random",
  },
  {
    id: 196,
    label: 0,
    score: 0.445720939433306,
    data_type: "random",
  },
  {
    id: 197,
    label: 0,
    score: 0.387591705157616,
    data_type: "random",
  },
  {
    id: 198,
    label: 0,
    score: 0.660924759931862,
    data_type: "random",
  },
  {
    id: 199,
    label: 0,
    score: 0.320213885440021,
    data_type: "random",
  },
  {
    id: 200,
    label: 0,
    score: 0.463618786608214,
    data_type: "random",
  },
  {
    id: 201,
    label: 0,
    score: 0.240438762990356,
    data_type: "random",
  },
  {
    id: 202,
    label: 0,
    score: 0.502572486471922,
    data_type: "random",
  },
  {
    id: 203,
    label: 0,
    score: 0.385437275459989,
    data_type: "random",
  },
  {
    id: 204,
    label: 0,
    score: 0.637743531371778,
    data_type: "random",
  },
  {
    id: 205,
    label: 0,
    score: 0.538257534449282,
    data_type: "random",
  },
  {
    id: 206,
    label: 0,
    score: 0.428247234377784,
    data_type: "random",
  },
  {
    id: 207,
    label: 0,
    score: 0.488842008888784,
    data_type: "random",
  },
  {
    id: 208,
    label: 0,
    score: 0.342293763612936,
    data_type: "random",
  },
  {
    id: 209,
    label: 0,
    score: 0.369701898032887,
    data_type: "random",
  },
  {
    id: 210,
    label: 0,
    score: 0.531910517693818,
    data_type: "random",
  },
  {
    id: 211,
    label: 0,
    score: 0.594473667215232,
    data_type: "random",
  },
  {
    id: 212,
    label: 0,
    score: 0.325751424926878,
    data_type: "random",
  },
  {
    id: 213,
    label: 0,
    score: 0.68298980268236,
    data_type: "random",
  },
  {
    id: 214,
    label: 0,
    score: 0.483289137387274,
    data_type: "random",
  },
  {
    id: 215,
    label: 0,
    score: 0.626422737080036,
    data_type: "random",
  },
  {
    id: 216,
    label: 0,
    score: 0.334399424770009,
    data_type: "random",
  },
  {
    id: 217,
    label: 0,
    score: 0.267972700577407,
    data_type: "random",
  },
  {
    id: 218,
    label: 0,
    score: 0.579974418838434,
    data_type: "random",
  },
  {
    id: 219,
    label: 0,
    score: 0.349234631086403,
    data_type: "random",
  },
  {
    id: 220,
    label: 0,
    score: 0.549262685157082,
    data_type: "random",
  },
  {
    id: 221,
    label: 0,
    score: 0.532094897492347,
    data_type: "random",
  },
  {
    id: 222,
    label: 0,
    score: 0.203737637699806,
    data_type: "random",
  },
  {
    id: 223,
    label: 0,
    score: 0.458742208793242,
    data_type: "random",
  },
  {
    id: 224,
    label: 0,
    score: 0.606185453343387,
    data_type: "random",
  },
  {
    id: 225,
    label: 0,
    score: 0.685364903721595,
    data_type: "random",
  },
  {
    id: 226,
    label: 0,
    score: 0.382554880304931,
    data_type: "random",
  },
  {
    id: 227,
    label: 0,
    score: 0.620855159501817,
    data_type: "random",
  },
  {
    id: 228,
    label: 0,
    score: 0.321457964830157,
    data_type: "random",
  },
  {
    id: 229,
    label: 0,
    score: 0.510286367313987,
    data_type: "random",
  },
  {
    id: 230,
    label: 0,
    score: 0.848812965076122,
    data_type: "random",
  },
  {
    id: 231,
    label: 0,
    score: 0.443579369058642,
    data_type: "random",
  },
  {
    id: 232,
    label: 0,
    score: 0.443097519279749,
    data_type: "random",
  },
  {
    id: 233,
    label: 0,
    score: 0.5058791435767,
    data_type: "random",
  },
  {
    id: 234,
    label: 0,
    score: 0.47779275494513,
    data_type: "random",
  },
  {
    id: 235,
    label: 0,
    score: 0.286808072635697,
    data_type: "random",
  },
  {
    id: 236,
    label: 0,
    score: 0.293584111112745,
    data_type: "random",
  },
  {
    id: 237,
    label: 0,
    score: 0.740933331525495,
    data_type: "random",
  },
  {
    id: 238,
    label: 0,
    score: 0.719297277064353,
    data_type: "random",
  },
  {
    id: 239,
    label: 0,
    score: 0.488762919594733,
    data_type: "random",
  },
  {
    id: 240,
    label: 0,
    score: 0.386239691237446,
    data_type: "random",
  },
  {
    id: 241,
    label: 0,
    score: 0.450534046817081,
    data_type: "random",
  },
  {
    id: 242,
    label: 0,
    score: 0.567626409162547,
    data_type: "random",
  },
  {
    id: 243,
    label: 0,
    score: 0.439278126864539,
    data_type: "random",
  },
  {
    id: 244,
    label: 0,
    score: 0.447994030189764,
    data_type: "random",
  },
  {
    id: 245,
    label: 0,
    score: 0.223173126684393,
    data_type: "random",
  },
  {
    id: 246,
    label: 0,
    score: 0.650110832932248,
    data_type: "random",
  },
  {
    id: 247,
    label: 0,
    score: 0.355708517253685,
    data_type: "random",
  },
  {
    id: 248,
    label: 0,
    score: 0.21780812987855,
    data_type: "random",
  },
  {
    id: 249,
    label: 0,
    score: 0.378157154080936,
    data_type: "random",
  },
  {
    id: 250,
    label: 0,
    score: 0.379357368370867,
    data_type: "random",
  },
  {
    id: 251,
    label: 0,
    score: 0.618940065829742,
    data_type: "random",
  },
  {
    id: 252,
    label: 0,
    score: 0.563683408324264,
    data_type: "random",
  },
  {
    id: 253,
    label: 0,
    score: 0.459955166583302,
    data_type: "random",
  },
  {
    id: 254,
    label: 0,
    score: 0.308588314385417,
    data_type: "random",
  },
  {
    id: 255,
    label: 0,
    score: 0.252852999814995,
    data_type: "random",
  },
  {
    id: 256,
    label: 0,
    score: 0.413606768985398,
    data_type: "random",
  },
  {
    id: 257,
    label: 0,
    score: 0.653486097446913,
    data_type: "random",
  },
  {
    id: 258,
    label: 0,
    score: 0.360434652605691,
    data_type: "random",
  },
  {
    id: 259,
    label: 0,
    score: 0.422906793937113,
    data_type: "random",
  },
  {
    id: 260,
    label: 0,
    score: 0.635868485007002,
    data_type: "random",
  },
  {
    id: 261,
    label: 0,
    score: 0.648185661531307,
    data_type: "random",
  },
  {
    id: 262,
    label: 0,
    score: 0.463911991869077,
    data_type: "random",
  },
  {
    id: 263,
    label: 0,
    score: 0.217031586114048,
    data_type: "random",
  },
  {
    id: 264,
    label: 0,
    score: 0.527293874407102,
    data_type: "random",
  },
  {
    id: 265,
    label: 0,
    score: 0.675742377509,
    data_type: "random",
  },
  {
    id: 266,
    label: 0,
    score: 0.597142670602243,
    data_type: "random",
  },
  {
    id: 267,
    label: 0,
    score: 0.389195030897828,
    data_type: "random",
  },
  {
    id: 268,
    label: 0,
    score: 0.559091407743227,
    data_type: "random",
  },
  {
    id: 269,
    label: 0,
    score: 0.487236361442153,
    data_type: "random",
  },
  {
    id: 270,
    label: 0,
    score: 0.505970030118558,
    data_type: "random",
  },
  {
    id: 271,
    label: 0,
    score: 0.607207382361721,
    data_type: "random",
  },
  {
    id: 272,
    label: 0,
    score: 0.305828177758351,
    data_type: "random",
  },
  {
    id: 273,
    label: 0,
    score: 0.265798542710717,
    data_type: "random",
  },
  {
    id: 274,
    label: 0,
    score: 0.636305187489834,
    data_type: "random",
  },
  {
    id: 275,
    label: 0,
    score: 0.395743224785767,
    data_type: "random",
  },
  {
    id: 276,
    label: 0,
    score: 0.404638697369634,
    data_type: "random",
  },
  {
    id: 277,
    label: 0,
    score: 0.427756836586951,
    data_type: "random",
  },
  {
    id: 278,
    label: 0,
    score: 0.64186549659189,
    data_type: "random",
  },
  {
    id: 279,
    label: 0,
    score: 0.316573266934676,
    data_type: "random",
  },
  {
    id: 280,
    label: 0,
    score: 0.340242647724626,
    data_type: "random",
  },
  {
    id: 281,
    label: 0,
    score: 0.461417704450248,
    data_type: "random",
  },
  {
    id: 282,
    label: 0,
    score: 0.478036536055312,
    data_type: "random",
  },
  {
    id: 283,
    label: 0,
    score: 0.391890105488599,
    data_type: "random",
  },
  {
    id: 284,
    label: 0,
    score: 0.55932916200955,
    data_type: "random",
  },
  {
    id: 285,
    label: 0,
    score: 0.484946923775,
    data_type: "random",
  },
  {
    id: 286,
    label: 0,
    score: 0.78520937288628,
    data_type: "random",
  },
  {
    id: 287,
    label: 0,
    score: 0.380004736091526,
    data_type: "random",
  },
  {
    id: 288,
    label: 0,
    score: 0.429061100657348,
    data_type: "random",
  },
  {
    id: 289,
    label: 0,
    score: 0.638343954602742,
    data_type: "random",
  },
  {
    id: 290,
    label: 0,
    score: 0.271456469075415,
    data_type: "random",
  },
  {
    id: 291,
    label: 0,
    score: 0.313138149719226,
    data_type: "random",
  },
  {
    id: 292,
    label: 0,
    score: 0.323905355292202,
    data_type: "random",
  },
  {
    id: 293,
    label: 0,
    score: 0.375366970538012,
    data_type: "random",
  },
  {
    id: 294,
    label: 0,
    score: 0.530676964240893,
    data_type: "random",
  },
  {
    id: 295,
    label: 0,
    score: 0.673075876428376,
    data_type: "random",
  },
  {
    id: 296,
    label: 0,
    score: 0.583140612325582,
    data_type: "random",
  },
  {
    id: 297,
    label: 0,
    score: 0.752114473509194,
    data_type: "random",
  },
  {
    id: 298,
    label: 0,
    score: 0.667231516385693,
    data_type: "random",
  },
  {
    id: 299,
    label: 0,
    score: 0.380301742762199,
    data_type: "random",
  },
  {
    id: 300,
    label: 0,
    score: 0.617994680759646,
    data_type: "random",
  },
  {
    id: 301,
    label: 0,
    score: 0.547731661843051,
    data_type: "random",
  },
  {
    id: 302,
    label: 0,
    score: 0.725531770791551,
    data_type: "random",
  },
  {
    id: 303,
    label: 0,
    score: 0.487483571641144,
    data_type: "random",
  },
  {
    id: 304,
    label: 0,
    score: 0.394170896296974,
    data_type: "random",
  },
  {
    id: 305,
    label: 0,
    score: 0.452002934335934,
    data_type: "random",
  },
  {
    id: 306,
    label: 0,
    score: 0.528412860324136,
    data_type: "random",
  },
  {
    id: 307,
    label: 0,
    score: 0.726203685015755,
    data_type: "random",
  },
  {
    id: 308,
    label: 0,
    score: 0.344866466617373,
    data_type: "random",
  },
  {
    id: 309,
    label: 0,
    score: 0.528730418826714,
    data_type: "random",
  },
  {
    id: 310,
    label: 0,
    score: 0.612094289161175,
    data_type: "random",
  },
  {
    id: 311,
    label: 0,
    score: 0.469812581394898,
    data_type: "random",
  },
  {
    id: 312,
    label: 0,
    score: 0.597091990914638,
    data_type: "random",
  },
  {
    id: 313,
    label: 0,
    score: 0.578896091946243,
    data_type: "random",
  },
  {
    id: 314,
    label: 0,
    score: 0.59072578322797,
    data_type: "random",
  },
  {
    id: 315,
    label: 0,
    score: 0.187311997652409,
    data_type: "random",
  },
  {
    id: 316,
    label: 0,
    score: 0.505950578437384,
    data_type: "random",
  },
  {
    id: 317,
    label: 0,
    score: 0.772844752976568,
    data_type: "random",
  },
  {
    id: 318,
    label: 0,
    score: 0.441804709045448,
    data_type: "random",
  },
  {
    id: 319,
    label: 0,
    score: 0.29434503160994,
    data_type: "random",
  },
  {
    id: 320,
    label: 0,
    score: 0.44484704238482,
    data_type: "random",
  },
  {
    id: 321,
    label: 0,
    score: 0.772570762576577,
    data_type: "random",
  },
  {
    id: 322,
    label: 0,
    score: 0.675209771738395,
    data_type: "random",
  },
  {
    id: 323,
    label: 0,
    score: 0.455108354263207,
    data_type: "random",
  },
  {
    id: 324,
    label: 0,
    score: 0.234722641541386,
    data_type: "random",
  },
  {
    id: 325,
    label: 0,
    score: 0.513140665680121,
    data_type: "random",
  },
  {
    id: 326,
    label: 0,
    score: 0.328630690271822,
    data_type: "random",
  },
  {
    id: 327,
    label: 0,
    score: 0.683675380687261,
    data_type: "random",
  },
  {
    id: 328,
    label: 0,
    score: 0.261424411835656,
    data_type: "random",
  },
  {
    id: 329,
    label: 0,
    score: 0.525517670454419,
    data_type: "random",
  },
  {
    id: 330,
    label: 0,
    score: 0.503412569652089,
    data_type: "random",
  },
  {
    id: 331,
    label: 0,
    score: 0.501102349702623,
    data_type: "random",
  },
  {
    id: 332,
    label: 0,
    score: 0.667955897708429,
    data_type: "random",
  },
  {
    id: 333,
    label: 0,
    score: 0.470842325925478,
    data_type: "random",
  },
  {
    id: 334,
    label: 0,
    score: 0.434669518233837,
    data_type: "random",
  },
  {
    id: 335,
    label: 0,
    score: 0.360091591708997,
    data_type: "random",
  },
  {
    id: 336,
    label: 0,
    score: 0.248674583073768,
    data_type: "random",
  },
  {
    id: 337,
    label: 0,
    score: 0.664992183071656,
    data_type: "random",
  },
  {
    id: 338,
    label: 0,
    score: 0.481873815492444,
    data_type: "random",
  },
  {
    id: 339,
    label: 0,
    score: 0.468453684445008,
    data_type: "random",
  },
  {
    id: 340,
    label: 0,
    score: 0.358523950363139,
    data_type: "random",
  },
  {
    id: 341,
    label: 0,
    score: 0.46155594241384,
    data_type: "random",
  },
  {
    id: 342,
    label: 0,
    score: 0.312361310004005,
    data_type: "random",
  },
  {
    id: 343,
    label: 0,
    score: 0.641759964600745,
    data_type: "random",
  },
  {
    id: 344,
    label: 0,
    score: 0.627525803855507,
    data_type: "random",
  },
  {
    id: 345,
    label: 0,
    score: 0.642192915563939,
    data_type: "random",
  },
  {
    id: 346,
    label: 0,
    score: 0.41679705389449,
    data_type: "random",
  },
  {
    id: 347,
    label: 0,
    score: 0.232919647815076,
    data_type: "random",
  },
  {
    id: 348,
    label: 0,
    score: 0.69534232582387,
    data_type: "random",
  },
  {
    id: 349,
    label: 0,
    score: 0.312813386124744,
    data_type: "random",
  },
  {
    id: 350,
    label: 0,
    score: 0.497097179872787,
    data_type: "random",
  },
  {
    id: 351,
    label: 0,
    score: 0.232371146701344,
    data_type: "random",
  },
  {
    id: 352,
    label: 0,
    score: 0.545725576616152,
    data_type: "random",
  },
  {
    id: 353,
    label: 0,
    score: 0.434383252604896,
    data_type: "random",
  },
  {
    id: 354,
    label: 0,
    score: 0.331955960117063,
    data_type: "random",
  },
  {
    id: 355,
    label: 0,
    score: 0.463062925485918,
    data_type: "random",
  },
  {
    id: 356,
    label: 0,
    score: 0.631958638731703,
    data_type: "random",
  },
  {
    id: 357,
    label: 0,
    score: 0.420563167353358,
    data_type: "random",
  },
  {
    id: 358,
    label: 0,
    score: 0.441073760137763,
    data_type: "random",
  },
  {
    id: 359,
    label: 0,
    score: 0.408608078134351,
    data_type: "random",
  },
  {
    id: 360,
    label: 0,
    score: 0.661641153246255,
    data_type: "random",
  },
  {
    id: 361,
    label: 0,
    score: 0.577694680223249,
    data_type: "random",
  },
  {
    id: 362,
    label: 0,
    score: 0.518558764259843,
    data_type: "random",
  },
  {
    id: 363,
    label: 0,
    score: 0.618456682355754,
    data_type: "random",
  },
  {
    id: 364,
    label: 0,
    score: 0.748859050199939,
    data_type: "random",
  },
  {
    id: 365,
    label: 0,
    score: 0.343013992019385,
    data_type: "random",
  },
  {
    id: 366,
    label: 0,
    score: 0.723838931784876,
    data_type: "random",
  },
  {
    id: 367,
    label: 0,
    score: 0.288067911210202,
    data_type: "random",
  },
  {
    id: 368,
    label: 0,
    score: 0.51302256388272,
    data_type: "random",
  },
  {
    id: 369,
    label: 0,
    score: 0.52116545778007,
    data_type: "random",
  },
  {
    id: 370,
    label: 0,
    score: 0.698364877933514,
    data_type: "random",
  },
  {
    id: 371,
    label: 0,
    score: 0.271571727367007,
    data_type: "random",
  },
  {
    id: 372,
    label: 0,
    score: 0.360278510999367,
    data_type: "random",
  },
  {
    id: 373,
    label: 0,
    score: 0.255430343504073,
    data_type: "random",
  },
  {
    id: 374,
    label: 0,
    score: 0.675650528106163,
    data_type: "random",
  },
  {
    id: 375,
    label: 0,
    score: 0.715463746650675,
    data_type: "random",
  },
  {
    id: 376,
    label: 0,
    score: 0.369167330675941,
    data_type: "random",
  },
  {
    id: 377,
    label: 0,
    score: 0.311456442433552,
    data_type: "random",
  },
  {
    id: 378,
    label: 0,
    score: 0.33391482377697,
    data_type: "random",
  },
  {
    id: 379,
    label: 0,
    score: 0.289844442806632,
    data_type: "random",
  },
  {
    id: 380,
    label: 0,
    score: 0.212967626266995,
    data_type: "random",
  },
  {
    id: 381,
    label: 0,
    score: 0.225453541699985,
    data_type: "random",
  },
  {
    id: 382,
    label: 0,
    score: 0.730760146468607,
    data_type: "random",
  },
  {
    id: 383,
    label: 0,
    score: 0.392608729678961,
    data_type: "random",
  },
  {
    id: 384,
    label: 0,
    score: 0.432686724767125,
    data_type: "random",
  },
  {
    id: 385,
    label: 0,
    score: 0.498747403774015,
    data_type: "random",
  },
  {
    id: 386,
    label: 0,
    score: 0.571485135225756,
    data_type: "random",
  },
  {
    id: 387,
    label: 0,
    score: 0.652980271758786,
    data_type: "random",
  },
  {
    id: 388,
    label: 0,
    score: 0.238499285955909,
    data_type: "random",
  },
  {
    id: 389,
    label: 0,
    score: 0.363983931608901,
    data_type: "random",
  },
  {
    id: 390,
    label: 0,
    score: 0.203320704627905,
    data_type: "random",
  },
  {
    id: 391,
    label: 0,
    score: 0.550068582767473,
    data_type: "random",
  },
  {
    id: 392,
    label: 0,
    score: 0.412263804094422,
    data_type: "random",
  },
  {
    id: 393,
    label: 0,
    score: 0.52077566722904,
    data_type: "random",
  },
  {
    id: 394,
    label: 0,
    score: 0.492502864532665,
    data_type: "random",
  },
  {
    id: 395,
    label: 0,
    score: 0.501845653572189,
    data_type: "random",
  },
  {
    id: 396,
    label: 0,
    score: 0.456236112456534,
    data_type: "random",
  },
  {
    id: 397,
    label: 0,
    score: 0.470464563125956,
    data_type: "random",
  },
  {
    id: 398,
    label: 0,
    score: 0.29668192712338,
    data_type: "random",
  },
  {
    id: 399,
    label: 0,
    score: 0.567177071526886,
    data_type: "random",
  },
  {
    id: 400,
    label: 0,
    score: 0.607156423021196,
    data_type: "random",
  },
  {
    id: 401,
    label: 0,
    score: 0.409376614359778,
    data_type: "random",
  },
  {
    id: 402,
    label: 0,
    score: 0.564044622085894,
    data_type: "random",
  },
  {
    id: 403,
    label: 0,
    score: 0.244519614171656,
    data_type: "random",
  },
  {
    id: 404,
    label: 0,
    score: 0.396273517474624,
    data_type: "random",
  },
  {
    id: 405,
    label: 0,
    score: 0.345406405018059,
    data_type: "random",
  },
  {
    id: 406,
    label: 0,
    score: 0.392413431210415,
    data_type: "random",
  },
  {
    id: 407,
    label: 0,
    score: 0.265653013759026,
    data_type: "random",
  },
  {
    id: 408,
    label: 0,
    score: 0.694418669082775,
    data_type: "random",
  },
  {
    id: 409,
    label: 0,
    score: 0.695479185631142,
    data_type: "random",
  },
  {
    id: 410,
    label: 0,
    score: 0.441555374087726,
    data_type: "random",
  },
  {
    id: 411,
    label: 0,
    score: 0.21250942711506,
    data_type: "random",
  },
  {
    id: 412,
    label: 0,
    score: 0.462418360079666,
    data_type: "random",
  },
  {
    id: 413,
    label: 0,
    score: 0.385238199906481,
    data_type: "random",
  },
  {
    id: 414,
    label: 0,
    score: 0.662826944761235,
    data_type: "random",
  },
  {
    id: 415,
    label: 0,
    score: 0.604459912459503,
    data_type: "random",
  },
  {
    id: 416,
    label: 0,
    score: 0.315766004538057,
    data_type: "random",
  },
  {
    id: 417,
    label: 0,
    score: 0.476322288718537,
    data_type: "random",
  },
  {
    id: 418,
    label: 0,
    score: 0.274855997950916,
    data_type: "random",
  },
  {
    id: 419,
    label: 0,
    score: 0.307205470751718,
    data_type: "random",
  },
  {
    id: 420,
    label: 0,
    score: 0.255523520874398,
    data_type: "random",
  },
  {
    id: 421,
    label: 0,
    score: 0.376703665911921,
    data_type: "random",
  },
  {
    id: 422,
    label: 0,
    score: 0.551392901205868,
    data_type: "random",
  },
  {
    id: 423,
    label: 0,
    score: 0.441672556085154,
    data_type: "random",
  },
  {
    id: 424,
    label: 0,
    score: 0.476234861793775,
    data_type: "random",
  },
  {
    id: 425,
    label: 0,
    score: 0.368177263388997,
    data_type: "random",
  },
  {
    id: 426,
    label: 0,
    score: 0.563177970042677,
    data_type: "random",
  },
  {
    id: 427,
    label: 0,
    score: 0.601627601225862,
    data_type: "random",
  },
  {
    id: 428,
    label: 0,
    score: 0.370797798889624,
    data_type: "random",
  },
  {
    id: 429,
    label: 0,
    score: 0.234622015237356,
    data_type: "random",
  },
  {
    id: 430,
    label: 0,
    score: 0.374652975537815,
    data_type: "random",
  },
  {
    id: 431,
    label: 0,
    score: 0.380168784308732,
    data_type: "random",
  },
  {
    id: 432,
    label: 0,
    score: 0.26097825136,
    data_type: "random",
  },
  {
    id: 433,
    label: 0,
    score: 0.56923621738287,
    data_type: "random",
  },
  {
    id: 434,
    label: 0,
    score: 0.480292784500939,
    data_type: "random",
  },
  {
    id: 435,
    label: 0,
    score: 0.243754717937062,
    data_type: "random",
  },
  {
    id: 436,
    label: 0,
    score: 0.333653260527195,
    data_type: "random",
  },
  {
    id: 437,
    label: 0,
    score: 0.671903390261092,
    data_type: "random",
  },
  {
    id: 438,
    label: 0,
    score: 0.238922338991768,
    data_type: "random",
  },
  {
    id: 439,
    label: 0,
    score: 0.491988789145497,
    data_type: "random",
  },
  {
    id: 440,
    label: 0,
    score: 0.309575373804474,
    data_type: "random",
  },
  {
    id: 441,
    label: 0,
    score: 0.320907427349479,
    data_type: "random",
  },
  {
    id: 442,
    label: 0,
    score: 0.786621111883073,
    data_type: "random",
  },
  {
    id: 443,
    label: 0,
    score: 0.330654687100715,
    data_type: "random",
  },
  {
    id: 444,
    label: 0,
    score: 0.464392142170016,
    data_type: "random",
  },
  {
    id: 445,
    label: 0,
    score: 0.231921486879272,
    data_type: "random",
  },
  {
    id: 446,
    label: 0,
    score: 0.653737395531895,
    data_type: "random",
  },
  {
    id: 447,
    label: 0,
    score: 0.549891677975668,
    data_type: "random",
  },
  {
    id: 448,
    label: 0,
    score: 0.345766406024422,
    data_type: "random",
  },
  {
    id: 449,
    label: 0,
    score: 0.586471971947178,
    data_type: "random",
  },
  {
    id: 450,
    label: 0,
    score: 0.546212918688504,
    data_type: "random",
  },
  {
    id: 451,
    label: 0,
    score: 0.440052685377852,
    data_type: "random",
  },
  {
    id: 452,
    label: 0,
    score: 0.483708998652729,
    data_type: "random",
  },
  {
    id: 453,
    label: 0,
    score: 0.285444308859326,
    data_type: "random",
  },
  {
    id: 454,
    label: 0,
    score: 0.332801555247743,
    data_type: "random",
  },
  {
    id: 455,
    label: 0,
    score: 0.630510622131914,
    data_type: "random",
  },
  {
    id: 456,
    label: 0,
    score: 0.628069127264641,
    data_type: "random",
  },
  {
    id: 457,
    label: 0,
    score: 0.606362748054732,
    data_type: "random",
  },
  {
    id: 458,
    label: 0,
    score: 0.450934775072821,
    data_type: "random",
  },
  {
    id: 459,
    label: 0,
    score: 0.326646419889486,
    data_type: "random",
  },
  {
    id: 460,
    label: 0,
    score: 0.572931361462628,
    data_type: "random",
  },
  {
    id: 461,
    label: 0,
    score: 0.550765190162989,
    data_type: "random",
  },
  {
    id: 462,
    label: 0,
    score: 0.407478921377876,
    data_type: "random",
  },
  {
    id: 463,
    label: 0,
    score: 0.521308323611812,
    data_type: "random",
  },
  {
    id: 464,
    label: 0,
    score: 0.725258947312656,
    data_type: "random",
  },
  {
    id: 465,
    label: 0,
    score: 0.335348091151282,
    data_type: "random",
  },
  {
    id: 466,
    label: 0,
    score: 0.267446017830298,
    data_type: "random",
  },
  {
    id: 467,
    label: 0,
    score: 0.580699237897149,
    data_type: "random",
  },
  {
    id: 468,
    label: 0,
    score: 0.512141201912154,
    data_type: "random",
  },
  {
    id: 469,
    label: 0,
    score: 0.378800941199716,
    data_type: "random",
  },
  {
    id: 470,
    label: 0,
    score: 0.399057591701406,
    data_type: "random",
  },
  {
    id: 471,
    label: 0,
    score: 0.379503689956202,
    data_type: "random",
  },
  {
    id: 472,
    label: 0,
    score: 0.585842697478915,
    data_type: "random",
  },
  {
    id: 473,
    label: 0,
    score: 0.307051727876878,
    data_type: "random",
  },
  {
    id: 474,
    label: 0,
    score: 0.567515286750506,
    data_type: "random",
  },
  {
    id: 475,
    label: 0,
    score: 0.432746396971967,
    data_type: "random",
  },
  {
    id: 476,
    label: 0,
    score: 0.638633516642376,
    data_type: "random",
  },
  {
    id: 477,
    label: 0,
    score: 0.620683845952361,
    data_type: "random",
  },
  {
    id: 478,
    label: 0,
    score: 0.504641535477287,
    data_type: "random",
  },
  {
    id: 479,
    label: 0,
    score: 0.423471722470239,
    data_type: "random",
  },
  {
    id: 480,
    label: 0,
    score: 0.570369785430171,
    data_type: "random",
  },
  {
    id: 481,
    label: 0,
    score: 0.523854217059902,
    data_type: "random",
  },
  {
    id: 482,
    label: 0,
    score: 0.643840249085969,
    data_type: "random",
  },
  {
    id: 483,
    label: 0,
    score: 0.287001107561854,
    data_type: "random",
  },
  {
    id: 484,
    label: 0,
    score: 0.497894297680607,
    data_type: "random",
  },
  {
    id: 485,
    label: 0,
    score: 0.502107286559122,
    data_type: "random",
  },
  {
    id: 486,
    label: 0,
    score: 0.578623547803115,
    data_type: "random",
  },
  {
    id: 487,
    label: 0,
    score: 0.711942663328193,
    data_type: "random",
  },
  {
    id: 488,
    label: 0,
    score: 0.23094461925954,
    data_type: "random",
  },
  {
    id: 489,
    label: 0,
    score: 0.602626056667636,
    data_type: "random",
  },
  {
    id: 490,
    label: 0,
    score: 0.295427673298,
    data_type: "random",
  },
  {
    id: 491,
    label: 0,
    score: 0.243444400694803,
    data_type: "random",
  },
  {
    id: 492,
    label: 0,
    score: 0.365145770855921,
    data_type: "random",
  },
  {
    id: 493,
    label: 0,
    score: 0.365404305247182,
    data_type: "random",
  },
  {
    id: 494,
    label: 0,
    score: 0.32281277985538,
    data_type: "random",
  },
  {
    id: 495,
    label: 0,
    score: 0.505439412115401,
    data_type: "random",
  },
  {
    id: 496,
    label: 0,
    score: 0.322145762552278,
    data_type: "random",
  },
  {
    id: 497,
    label: 0,
    score: 0.440353727283849,
    data_type: "random",
  },
  {
    id: 498,
    label: 0,
    score: 0.416321496696731,
    data_type: "random",
  },
  {
    id: 499,
    label: 0,
    score: 0.635916061156232,
    data_type: "random",
  },
  {
    id: 500,
    label: 0,
    score: 0.46969741020676,
    data_type: "random",
  },
  {
    id: 501,
    label: 1,
    score: 0.649649718459458,
    data_type: "random",
  },
  {
    id: 502,
    label: 1,
    score: 0.448837735150649,
    data_type: "random",
  },
  {
    id: 503,
    label: 1,
    score: 0.832323296153428,
    data_type: "random",
  },
  {
    id: 504,
    label: 1,
    score: 0.483323316681372,
    data_type: "random",
  },
  {
    id: 505,
    label: 1,
    score: 0.549803337751956,
    data_type: "random",
  },
  {
    id: 506,
    label: 1,
    score: 0.770620949295113,
    data_type: "random",
  },
  {
    id: 507,
    label: 1,
    score: 0.618293322954095,
    data_type: "random",
  },
  {
    id: 508,
    label: 1,
    score: 0.605621731613129,
    data_type: "random",
  },
  {
    id: 509,
    label: 1,
    score: 0.371371562266031,
    data_type: "random",
  },
  {
    id: 510,
    label: 1,
    score: 0.636659932906822,
    data_type: "random",
  },
  {
    id: 511,
    label: 1,
    score: 0.739498745849438,
    data_type: "random",
  },
  {
    id: 512,
    label: 1,
    score: 0.523868161924834,
    data_type: "random",
  },
  {
    id: 513,
    label: 1,
    score: 0.612383627083842,
    data_type: "random",
  },
  {
    id: 514,
    label: 1,
    score: 0.509608582759901,
    data_type: "random",
  },
  {
    id: 515,
    label: 1,
    score: 0.612018659300238,
    data_type: "random",
  },
  {
    id: 516,
    label: 1,
    score: 0.459304656736421,
    data_type: "random",
  },
  {
    id: 517,
    label: 1,
    score: 0.33253419183265,
    data_type: "random",
  },
  {
    id: 518,
    label: 1,
    score: 0.406053915531745,
    data_type: "random",
  },
  {
    id: 519,
    label: 1,
    score: 0.826985008886762,
    data_type: "random",
  },
  {
    id: 520,
    label: 1,
    score: 0.658152379583013,
    data_type: "random",
  },
  {
    id: 521,
    label: 1,
    score: 0.550983920379733,
    data_type: "random",
  },
  {
    id: 522,
    label: 1,
    score: 0.625787567050546,
    data_type: "random",
  },
  {
    id: 523,
    label: 1,
    score: 0.662206020797555,
    data_type: "random",
  },
  {
    id: 524,
    label: 1,
    score: 0.643847846684618,
    data_type: "random",
  },
  {
    id: 525,
    label: 1,
    score: 0.735791733646783,
    data_type: "random",
  },
  {
    id: 526,
    label: 1,
    score: 0.392283630787267,
    data_type: "random",
  },
  {
    id: 527,
    label: 1,
    score: 0.425467746087439,
    data_type: "random",
  },
  {
    id: 528,
    label: 1,
    score: 0.384282791361737,
    data_type: "random",
  },
  {
    id: 529,
    label: 1,
    score: 0.586264164794793,
    data_type: "random",
  },
  {
    id: 530,
    label: 1,
    score: 0.657669798631401,
    data_type: "random",
  },
  {
    id: 531,
    label: 1,
    score: 0.418426352993371,
    data_type: "random",
  },
  {
    id: 532,
    label: 1,
    score: 0.591241553254777,
    data_type: "random",
  },
  {
    id: 533,
    label: 1,
    score: 0.571325405959579,
    data_type: "random",
  },
  {
    id: 534,
    label: 1,
    score: 0.642102390888643,
    data_type: "random",
  },
  {
    id: 535,
    label: 1,
    score: 0.398749950236281,
    data_type: "random",
  },
  {
    id: 536,
    label: 1,
    score: 0.61599765484967,
    data_type: "random",
  },
  {
    id: 537,
    label: 1,
    score: 0.625854307534663,
    data_type: "random",
  },
  {
    id: 538,
    label: 1,
    score: 0.704592678511298,
    data_type: "random",
  },
  {
    id: 539,
    label: 1,
    score: 0.841619073499162,
    data_type: "random",
  },
  {
    id: 540,
    label: 1,
    score: 0.644302722771791,
    data_type: "random",
  },
  {
    id: 541,
    label: 1,
    score: 0.454026523778172,
    data_type: "random",
  },
  {
    id: 542,
    label: 1,
    score: 0.596475255101982,
    data_type: "random",
  },
  {
    id: 543,
    label: 1,
    score: 0.5547471158283,
    data_type: "random",
  },
  {
    id: 544,
    label: 1,
    score: 0.315516609892712,
    data_type: "random",
  },
  {
    id: 545,
    label: 1,
    score: 0.576468894513121,
    data_type: "random",
  },
  {
    id: 546,
    label: 1,
    score: 0.753679142682177,
    data_type: "random",
  },
  {
    id: 547,
    label: 1,
    score: 0.692454230397407,
    data_type: "random",
  },
  {
    id: 548,
    label: 1,
    score: 0.304519158628553,
    data_type: "random",
  },
  {
    id: 549,
    label: 1,
    score: 0.595534752415268,
    data_type: "random",
  },
  {
    id: 550,
    label: 1,
    score: 0.587122821743958,
    data_type: "random",
  },
  {
    id: 551,
    label: 1,
    score: 0.476174645073544,
    data_type: "random",
  },
  {
    id: 552,
    label: 1,
    score: 0.649752450889008,
    data_type: "random",
  },
  {
    id: 553,
    label: 1,
    score: 0.608877659903003,
    data_type: "random",
  },
  {
    id: 554,
    label: 1,
    score: 0.694463986235118,
    data_type: "random",
  },
  {
    id: 555,
    label: 1,
    score: 0.585126458703126,
    data_type: "random",
  },
  {
    id: 556,
    label: 1,
    score: 0.477114434852922,
    data_type: "random",
  },
  {
    id: 557,
    label: 1,
    score: 0.712314271962663,
    data_type: "random",
  },
  {
    id: 558,
    label: 1,
    score: 0.715029332862998,
    data_type: "random",
  },
  {
    id: 559,
    label: 1,
    score: 0.777003762855133,
    data_type: "random",
  },
  {
    id: 560,
    label: 1,
    score: 0.431142847767782,
    data_type: "random",
  },
  {
    id: 561,
    label: 1,
    score: 0.613092456480267,
    data_type: "random",
  },
  {
    id: 562,
    label: 1,
    score: 0.571237409524473,
    data_type: "random",
  },
  {
    id: 563,
    label: 1,
    score: 0.440894738086749,
    data_type: "random",
  },
  {
    id: 564,
    label: 1,
    score: 0.393373435798159,
    data_type: "random",
  },
  {
    id: 565,
    label: 1,
    score: 0.3661529831807,
    data_type: "random",
  },
  {
    id: 566,
    label: 1,
    score: 0.68245607101903,
    data_type: "random",
  },
  {
    id: 567,
    label: 1,
    score: 0.713123111058517,
    data_type: "random",
  },
  {
    id: 568,
    label: 1,
    score: 0.570537642465742,
    data_type: "random",
  },
  {
    id: 569,
    label: 1,
    score: 0.557694328834009,
    data_type: "random",
  },
  {
    id: 570,
    label: 1,
    score: 0.356230112002735,
    data_type: "random",
  },
  {
    id: 571,
    label: 1,
    score: 0.605539726104077,
    data_type: "random",
  },
  {
    id: 572,
    label: 1,
    score: 0.700461251043623,
    data_type: "random",
  },
  {
    id: 573,
    label: 1,
    score: 0.74763867644699,
    data_type: "random",
  },
  {
    id: 574,
    label: 1,
    score: 0.481265151711807,
    data_type: "random",
  },
  {
    id: 575,
    label: 1,
    score: 0.311875616732059,
    data_type: "random",
  },
  {
    id: 576,
    label: 1,
    score: 0.784246347820595,
    data_type: "random",
  },
  {
    id: 577,
    label: 1,
    score: 0.710509718884847,
    data_type: "random",
  },
  {
    id: 578,
    label: 1,
    score: 0.715020769853148,
    data_type: "random",
  },
  {
    id: 579,
    label: 1,
    score: 0.408149628543122,
    data_type: "random",
  },
  {
    id: 580,
    label: 1,
    score: 0.555660613321273,
    data_type: "random",
  },
  {
    id: 581,
    label: 1,
    score: 0.578877143444646,
    data_type: "random",
  },
  {
    id: 582,
    label: 1,
    score: 0.680224320780325,
    data_type: "random",
  },
  {
    id: 583,
    label: 1,
    score: 0.436074249376027,
    data_type: "random",
  },
  {
    id: 584,
    label: 1,
    score: 0.706671411226904,
    data_type: "random",
  },
  {
    id: 585,
    label: 1,
    score: 0.59008886793684,
    data_type: "random",
  },
  {
    id: 586,
    label: 1,
    score: 0.524356147680225,
    data_type: "random",
  },
  {
    id: 587,
    label: 1,
    score: 0.39136194108795,
    data_type: "random",
  },
  {
    id: 588,
    label: 1,
    score: 0.754306696594224,
    data_type: "random",
  },
  {
    id: 589,
    label: 1,
    score: 0.686716783883189,
    data_type: "random",
  },
  {
    id: 590,
    label: 1,
    score: 0.306014942647319,
    data_type: "random",
  },
  {
    id: 591,
    label: 1,
    score: 0.672058687162959,
    data_type: "random",
  },
  {
    id: 592,
    label: 1,
    score: 0.482958668500496,
    data_type: "random",
  },
  {
    id: 593,
    label: 1,
    score: 0.677656430293551,
    data_type: "random",
  },
  {
    id: 594,
    label: 1,
    score: 0.701971430324597,
    data_type: "random",
  },
  {
    id: 595,
    label: 1,
    score: 0.754591211923339,
    data_type: "random",
  },
  {
    id: 596,
    label: 1,
    score: 0.563880736904278,
    data_type: "random",
  },
  {
    id: 597,
    label: 1,
    score: 0.632852746661441,
    data_type: "random",
  },
  {
    id: 598,
    label: 1,
    score: 0.517437476071825,
    data_type: "random",
  },
  {
    id: 599,
    label: 1,
    score: 0.235590002571397,
    data_type: "random",
  },
  {
    id: 600,
    label: 1,
    score: 0.607913285030613,
    data_type: "random",
  },
  {
    id: 601,
    label: 1,
    score: 0.58131114627002,
    data_type: "random",
  },
  {
    id: 602,
    label: 1,
    score: 0.638270798982643,
    data_type: "random",
  },
  {
    id: 603,
    label: 1,
    score: 0.659491358810111,
    data_type: "random",
  },
  {
    id: 604,
    label: 1,
    score: 0.721189956040082,
    data_type: "random",
  },
  {
    id: 605,
    label: 1,
    score: 0.635260831314866,
    data_type: "random",
  },
  {
    id: 606,
    label: 1,
    score: 0.59247122020659,
    data_type: "random",
  },
  {
    id: 607,
    label: 1,
    score: 0.631433444661975,
    data_type: "random",
  },
  {
    id: 608,
    label: 1,
    score: 0.479296872762188,
    data_type: "random",
  },
  {
    id: 609,
    label: 1,
    score: 0.608436081303245,
    data_type: "random",
  },
  {
    id: 610,
    label: 1,
    score: 0.5607567926094,
    data_type: "random",
  },
  {
    id: 611,
    label: 1,
    score: 0.598338430489929,
    data_type: "random",
  },
  {
    id: 612,
    label: 1,
    score: 0.592176226017533,
    data_type: "random",
  },
  {
    id: 613,
    label: 1,
    score: 0.582975306066843,
    data_type: "random",
  },
  {
    id: 614,
    label: 1,
    score: 0.673759409516149,
    data_type: "random",
  },
  {
    id: 615,
    label: 1,
    score: 0.501110638891066,
    data_type: "random",
  },
  {
    id: 616,
    label: 1,
    score: 0.504453467231681,
    data_type: "random",
  },
  {
    id: 617,
    label: 1,
    score: 0.475915182792712,
    data_type: "random",
  },
  {
    id: 618,
    label: 1,
    score: 0.688866418821477,
    data_type: "random",
  },
  {
    id: 619,
    label: 1,
    score: 0.702929384245774,
    data_type: "random",
  },
  {
    id: 620,
    label: 1,
    score: 0.506963567198064,
    data_type: "random",
  },
  {
    id: 621,
    label: 1,
    score: 0.492689291476269,
    data_type: "random",
  },
  {
    id: 622,
    label: 1,
    score: 0.569922460085335,
    data_type: "random",
  },
  {
    id: 623,
    label: 1,
    score: 0.735438381195285,
    data_type: "random",
  },
  {
    id: 624,
    label: 1,
    score: 0.595751829300715,
    data_type: "random",
  },
  {
    id: 625,
    label: 1,
    score: 0.499781618930343,
    data_type: "random",
  },
  {
    id: 626,
    label: 1,
    score: 0.619324149998163,
    data_type: "random",
  },
  {
    id: 627,
    label: 1,
    score: 0.381860272006567,
    data_type: "random",
  },
  {
    id: 628,
    label: 1,
    score: 0.462224208747446,
    data_type: "random",
  },
  {
    id: 629,
    label: 1,
    score: 0.605773753534719,
    data_type: "random",
  },
  {
    id: 630,
    label: 1,
    score: 0.609498924488938,
    data_type: "random",
  },
  {
    id: 631,
    label: 1,
    score: 0.737535079633024,
    data_type: "random",
  },
  {
    id: 632,
    label: 1,
    score: 0.434754555977179,
    data_type: "random",
  },
  {
    id: 633,
    label: 1,
    score: 0.784558517747944,
    data_type: "random",
  },
  {
    id: 634,
    label: 1,
    score: 0.348038838570074,
    data_type: "random",
  },
  {
    id: 635,
    label: 1,
    score: 0.509649126825508,
    data_type: "random",
  },
  {
    id: 636,
    label: 1,
    score: 0.431641266336212,
    data_type: "random",
  },
  {
    id: 637,
    label: 1,
    score: 0.606270417164896,
    data_type: "random",
  },
  {
    id: 638,
    label: 1,
    score: 0.605058170574015,
    data_type: "random",
  },
  {
    id: 639,
    label: 1,
    score: 0.415952278672746,
    data_type: "random",
  },
  {
    id: 640,
    label: 1,
    score: 0.819135591100669,
    data_type: "random",
  },
  {
    id: 641,
    label: 1,
    score: 0.748811152875121,
    data_type: "random",
  },
  {
    id: 642,
    label: 1,
    score: 0.368178367890852,
    data_type: "random",
  },
  {
    id: 643,
    label: 1,
    score: 0.43869715364984,
    data_type: "random",
  },
  {
    id: 644,
    label: 1,
    score: 0.517770055606998,
    data_type: "random",
  },
  {
    id: 645,
    label: 1,
    score: 0.348419899493271,
    data_type: "random",
  },
  {
    id: 646,
    label: 1,
    score: 0.832196869298344,
    data_type: "random",
  },
  {
    id: 647,
    label: 1,
    score: 0.577967056859872,
    data_type: "random",
  },
  {
    id: 648,
    label: 1,
    score: 0.413409641914927,
    data_type: "random",
  },
  {
    id: 649,
    label: 1,
    score: 0.651817585052573,
    data_type: "random",
  },
  {
    id: 650,
    label: 1,
    score: 0.600790310527653,
    data_type: "random",
  },
  {
    id: 651,
    label: 1,
    score: 0.549279308796943,
    data_type: "random",
  },
  {
    id: 652,
    label: 1,
    score: 0.417237877391061,
    data_type: "random",
  },
  {
    id: 653,
    label: 1,
    score: 0.703599660172997,
    data_type: "random",
  },
  {
    id: 654,
    label: 1,
    score: 0.796557143238357,
    data_type: "random",
  },
  {
    id: 655,
    label: 1,
    score: 0.426003261278361,
    data_type: "random",
  },
  {
    id: 656,
    label: 1,
    score: 0.391096285157024,
    data_type: "random",
  },
  {
    id: 657,
    label: 1,
    score: 0.769647464386069,
    data_type: "random",
  },
  {
    id: 658,
    label: 1,
    score: 0.454212972077918,
    data_type: "random",
  },
  {
    id: 659,
    label: 1,
    score: 0.519745972710694,
    data_type: "random",
  },
  {
    id: 660,
    label: 1,
    score: 0.612718868446778,
    data_type: "random",
  },
  {
    id: 661,
    label: 1,
    score: 0.67613865602472,
    data_type: "random",
  },
  {
    id: 662,
    label: 1,
    score: 0.535103104168469,
    data_type: "random",
  },
  {
    id: 663,
    label: 1,
    score: 0.584761867315821,
    data_type: "random",
  },
  {
    id: 664,
    label: 1,
    score: 0.75879805569971,
    data_type: "random",
  },
  {
    id: 665,
    label: 1,
    score: 0.587133268732106,
    data_type: "random",
  },
  {
    id: 666,
    label: 1,
    score: 0.707474631148556,
    data_type: "random",
  },
  {
    id: 667,
    label: 1,
    score: 0.659325833182191,
    data_type: "random",
  },
  {
    id: 668,
    label: 1,
    score: 0.531699768606916,
    data_type: "random",
  },
  {
    id: 669,
    label: 1,
    score: 0.688694284586595,
    data_type: "random",
  },
  {
    id: 670,
    label: 1,
    score: 0.492288292840668,
    data_type: "random",
  },
  {
    id: 671,
    label: 1,
    score: 0.420806062900611,
    data_type: "random",
  },
  {
    id: 672,
    label: 1,
    score: 0.580724269307453,
    data_type: "random",
  },
  {
    id: 673,
    label: 1,
    score: 0.399014647272352,
    data_type: "random",
  },
  {
    id: 674,
    label: 1,
    score: 0.3956908514488,
    data_type: "random",
  },
  {
    id: 675,
    label: 1,
    score: 0.728316339569288,
    data_type: "random",
  },
  {
    id: 676,
    label: 1,
    score: 0.625387943840542,
    data_type: "random",
  },
  {
    id: 677,
    label: 1,
    score: 0.626057368911492,
    data_type: "random",
  },
  {
    id: 678,
    label: 1,
    score: 0.604630152839389,
    data_type: "random",
  },
  {
    id: 679,
    label: 1,
    score: 0.270889486904395,
    data_type: "random",
  },
  {
    id: 680,
    label: 1,
    score: 0.359488447733999,
    data_type: "random",
  },
  {
    id: 681,
    label: 1,
    score: 0.627207932661542,
    data_type: "random",
  },
  {
    id: 682,
    label: 1,
    score: 0.571562055928864,
    data_type: "random",
  },
  {
    id: 683,
    label: 1,
    score: 0.530234665544847,
    data_type: "random",
  },
  {
    id: 684,
    label: 1,
    score: 0.702340367930121,
    data_type: "random",
  },
  {
    id: 685,
    label: 1,
    score: 0.690709853326478,
    data_type: "random",
  },
  {
    id: 686,
    label: 1,
    score: 0.596782701201567,
    data_type: "random",
  },
  {
    id: 687,
    label: 1,
    score: 0.706533436645872,
    data_type: "random",
  },
  {
    id: 688,
    label: 1,
    score: 0.281186705460425,
    data_type: "random",
  },
  {
    id: 689,
    label: 1,
    score: 0.709881271981188,
    data_type: "random",
  },
  {
    id: 690,
    label: 1,
    score: 0.660693239588531,
    data_type: "random",
  },
  {
    id: 691,
    label: 1,
    score: 0.648327051693664,
    data_type: "random",
  },
  {
    id: 692,
    label: 1,
    score: 0.584488437816923,
    data_type: "random",
  },
  {
    id: 693,
    label: 1,
    score: 0.758738952281049,
    data_type: "random",
  },
  {
    id: 694,
    label: 1,
    score: 0.364298714224294,
    data_type: "random",
  },
  {
    id: 695,
    label: 1,
    score: 0.314414454822468,
    data_type: "random",
  },
  {
    id: 696,
    label: 1,
    score: 0.502742663592994,
    data_type: "random",
  },
  {
    id: 697,
    label: 1,
    score: 0.594872525254813,
    data_type: "random",
  },
  {
    id: 698,
    label: 1,
    score: 0.404859548372023,
    data_type: "random",
  },
  {
    id: 699,
    label: 1,
    score: 0.413609763513812,
    data_type: "random",
  },
  {
    id: 700,
    label: 1,
    score: 0.568363999554433,
    data_type: "random",
  },
  {
    id: 701,
    label: 1,
    score: 0.509325673021603,
    data_type: "random",
  },
  {
    id: 702,
    label: 1,
    score: 0.525376988940971,
    data_type: "random",
  },
  {
    id: 703,
    label: 1,
    score: 0.416195435002163,
    data_type: "random",
  },
  {
    id: 704,
    label: 1,
    score: 0.685259769756862,
    data_type: "random",
  },
  {
    id: 705,
    label: 1,
    score: 0.731930193617922,
    data_type: "random",
  },
  {
    id: 706,
    label: 1,
    score: 0.766590758131715,
    data_type: "random",
  },
  {
    id: 707,
    label: 1,
    score: 0.379282634132089,
    data_type: "random",
  },
  {
    id: 708,
    label: 1,
    score: 0.450352768195259,
    data_type: "random",
  },
  {
    id: 709,
    label: 1,
    score: 0.388666863541159,
    data_type: "random",
  },
  {
    id: 710,
    label: 1,
    score: 0.501132103065375,
    data_type: "random",
  },
  {
    id: 711,
    label: 1,
    score: 0.515337094357935,
    data_type: "random",
  },
  {
    id: 712,
    label: 1,
    score: 0.692067818169163,
    data_type: "random",
  },
  {
    id: 713,
    label: 1,
    score: 0.492513843027803,
    data_type: "random",
  },
  {
    id: 714,
    label: 1,
    score: 0.384830230950307,
    data_type: "random",
  },
  {
    id: 715,
    label: 1,
    score: 0.753116231668301,
    data_type: "random",
  },
  {
    id: 716,
    label: 1,
    score: 0.624589988195384,
    data_type: "random",
  },
  {
    id: 717,
    label: 1,
    score: 0.584966340262654,
    data_type: "random",
  },
  {
    id: 718,
    label: 1,
    score: 0.677974575081589,
    data_type: "random",
  },
  {
    id: 719,
    label: 1,
    score: 0.295564401911231,
    data_type: "random",
  },
  {
    id: 720,
    label: 1,
    score: 0.691010049237822,
    data_type: "random",
  },
  {
    id: 721,
    label: 1,
    score: 0.607062222666543,
    data_type: "random",
  },
  {
    id: 722,
    label: 1,
    score: 0.473675716822736,
    data_type: "random",
  },
  {
    id: 723,
    label: 1,
    score: 0.717333505000477,
    data_type: "random",
  },
  {
    id: 724,
    label: 1,
    score: 0.445997400230228,
    data_type: "random",
  },
  {
    id: 725,
    label: 1,
    score: 0.656643013703954,
    data_type: "random",
  },
  {
    id: 726,
    label: 1,
    score: 0.593652967081644,
    data_type: "random",
  },
  {
    id: 727,
    label: 1,
    score: 0.430056468667132,
    data_type: "random",
  },
  {
    id: 728,
    label: 1,
    score: 0.756867327877656,
    data_type: "random",
  },
  {
    id: 729,
    label: 1,
    score: 0.614758149516826,
    data_type: "random",
  },
  {
    id: 730,
    label: 1,
    score: 0.845601775335831,
    data_type: "random",
  },
  {
    id: 731,
    label: 1,
    score: 0.370484023511723,
    data_type: "random",
  },
  {
    id: 732,
    label: 1,
    score: 0.763663371375337,
    data_type: "random",
  },
  {
    id: 733,
    label: 1,
    score: 0.720555320476877,
    data_type: "random",
  },
  {
    id: 734,
    label: 1,
    score: 0.568949451085386,
    data_type: "random",
  },
  {
    id: 735,
    label: 1,
    score: 0.496861615561811,
    data_type: "random",
  },
  {
    id: 736,
    label: 1,
    score: 0.694412085168695,
    data_type: "random",
  },
  {
    id: 737,
    label: 1,
    score: 0.507872629783269,
    data_type: "random",
  },
  {
    id: 738,
    label: 1,
    score: 0.475206776794077,
    data_type: "random",
  },
  {
    id: 739,
    label: 1,
    score: 0.499048415662002,
    data_type: "random",
  },
  {
    id: 740,
    label: 1,
    score: 0.614803484727679,
    data_type: "random",
  },
  {
    id: 741,
    label: 1,
    score: 0.567558417746473,
    data_type: "random",
  },
  {
    id: 742,
    label: 1,
    score: 0.657629527420719,
    data_type: "random",
  },
  {
    id: 743,
    label: 1,
    score: 0.704081722376718,
    data_type: "random",
  },
  {
    id: 744,
    label: 1,
    score: 0.557031220271278,
    data_type: "random",
  },
  {
    id: 745,
    label: 1,
    score: 0.605950522618656,
    data_type: "random",
  },
  {
    id: 746,
    label: 1,
    score: 0.601257622265407,
    data_type: "random",
  },
  {
    id: 747,
    label: 1,
    score: 0.810569703673762,
    data_type: "random",
  },
  {
    id: 748,
    label: 1,
    score: 0.420243984857491,
    data_type: "random",
  },
  {
    id: 749,
    label: 1,
    score: 0.490629315813979,
    data_type: "random",
  },
  {
    id: 750,
    label: 1,
    score: 0.518511695921981,
    data_type: "random",
  },
  {
    id: 751,
    label: 1,
    score: 0.497991324882166,
    data_type: "random",
  },
  {
    id: 752,
    label: 1,
    score: 0.633173289391174,
    data_type: "random",
  },
  {
    id: 753,
    label: 1,
    score: 0.700769047544505,
    data_type: "random",
  },
  {
    id: 754,
    label: 1,
    score: 0.585440902564115,
    data_type: "random",
  },
  {
    id: 755,
    label: 1,
    score: 0.658985285120561,
    data_type: "random",
  },
  {
    id: 756,
    label: 1,
    score: 0.452818186124885,
    data_type: "random",
  },
  {
    id: 757,
    label: 1,
    score: 0.40575052965088,
    data_type: "random",
  },
  {
    id: 758,
    label: 1,
    score: 0.431656870368467,
    data_type: "random",
  },
  {
    id: 759,
    label: 1,
    score: 0.643447687685275,
    data_type: "random",
  },
  {
    id: 760,
    label: 1,
    score: 0.450398212462665,
    data_type: "random",
  },
  {
    id: 761,
    label: 1,
    score: 0.496595802161465,
    data_type: "random",
  },
  {
    id: 762,
    label: 1,
    score: 0.722797257855759,
    data_type: "random",
  },
  {
    id: 763,
    label: 1,
    score: 0.807413913975636,
    data_type: "random",
  },
  {
    id: 764,
    label: 1,
    score: 0.240425370549567,
    data_type: "random",
  },
  {
    id: 765,
    label: 1,
    score: 0.646006120388246,
    data_type: "random",
  },
  {
    id: 766,
    label: 1,
    score: 0.446200309820285,
    data_type: "random",
  },
  {
    id: 767,
    label: 1,
    score: 0.480768369474777,
    data_type: "random",
  },
  {
    id: 768,
    label: 1,
    score: 0.559571785645639,
    data_type: "random",
  },
  {
    id: 769,
    label: 1,
    score: 0.557465697794183,
    data_type: "random",
  },
  {
    id: 770,
    label: 1,
    score: 0.384670465765639,
    data_type: "random",
  },
  {
    id: 771,
    label: 1,
    score: 0.618727937651528,
    data_type: "random",
  },
  {
    id: 772,
    label: 1,
    score: 0.440239021076142,
    data_type: "random",
  },
  {
    id: 773,
    label: 1,
    score: 0.288971442476821,
    data_type: "random",
  },
  {
    id: 774,
    label: 1,
    score: 0.590968917333425,
    data_type: "random",
  },
  {
    id: 775,
    label: 1,
    score: 0.435667914338211,
    data_type: "random",
  },
  {
    id: 776,
    label: 1,
    score: 0.375257958792417,
    data_type: "random",
  },
  {
    id: 777,
    label: 1,
    score: 0.571511891029117,
    data_type: "random",
  },
  {
    id: 778,
    label: 1,
    score: 0.71296834471703,
    data_type: "random",
  },
  {
    id: 779,
    label: 1,
    score: 0.440935871908476,
    data_type: "random",
  },
  {
    id: 780,
    label: 1,
    score: 0.716098609026448,
    data_type: "random",
  },
  {
    id: 781,
    label: 1,
    score: 0.623446449823139,
    data_type: "random",
  },
  {
    id: 782,
    label: 1,
    score: 0.725116736978917,
    data_type: "random",
  },
  {
    id: 783,
    label: 1,
    score: 0.62996736252238,
    data_type: "random",
  },
  {
    id: 784,
    label: 1,
    score: 0.566442527675695,
    data_type: "random",
  },
  {
    id: 785,
    label: 1,
    score: 0.660052641147935,
    data_type: "random",
  },
  {
    id: 786,
    label: 1,
    score: 0.600218170251261,
    data_type: "random",
  },
  {
    id: 787,
    label: 1,
    score: 0.715513341474283,
    data_type: "random",
  },
  {
    id: 788,
    label: 1,
    score: 0.454690328327002,
    data_type: "random",
  },
  {
    id: 789,
    label: 1,
    score: 0.638120323077761,
    data_type: "random",
  },
  {
    id: 790,
    label: 1,
    score: 0.362331576510821,
    data_type: "random",
  },
  {
    id: 791,
    label: 1,
    score: 0.609069002032388,
    data_type: "random",
  },
  {
    id: 792,
    label: 1,
    score: 0.614952412977634,
    data_type: "random",
  },
  {
    id: 793,
    label: 1,
    score: 0.384774711901262,
    data_type: "random",
  },
  {
    id: 794,
    label: 1,
    score: 0.645459443741535,
    data_type: "random",
  },
  {
    id: 795,
    label: 1,
    score: 0.581819180709171,
    data_type: "random",
  },
  {
    id: 796,
    label: 1,
    score: 0.466830928216104,
    data_type: "random",
  },
  {
    id: 797,
    label: 1,
    score: 0.692515061370596,
    data_type: "random",
  },
  {
    id: 798,
    label: 1,
    score: 0.748048658221871,
    data_type: "random",
  },
  {
    id: 799,
    label: 1,
    score: 0.675722096326306,
    data_type: "random",
  },
  {
    id: 800,
    label: 1,
    score: 0.765996316013023,
    data_type: "random",
  },
  {
    id: 801,
    label: 1,
    score: 0.428050508311922,
    data_type: "random",
  },
  {
    id: 802,
    label: 1,
    score: 0.68478486856896,
    data_type: "random",
  },
  {
    id: 803,
    label: 1,
    score: 0.518931222431738,
    data_type: "random",
  },
  {
    id: 804,
    label: 1,
    score: 0.614585063235072,
    data_type: "random",
  },
  {
    id: 805,
    label: 1,
    score: 0.585423243592788,
    data_type: "random",
  },
  {
    id: 806,
    label: 1,
    score: 0.578397837026671,
    data_type: "random",
  },
  {
    id: 807,
    label: 1,
    score: 0.696303600148908,
    data_type: "random",
  },
  {
    id: 808,
    label: 1,
    score: 0.524401884639545,
    data_type: "random",
  },
  {
    id: 809,
    label: 1,
    score: 0.494010586701082,
    data_type: "random",
  },
  {
    id: 810,
    label: 1,
    score: 0.616467777822315,
    data_type: "random",
  },
  {
    id: 811,
    label: 1,
    score: 0.495472720062419,
    data_type: "random",
  },
  {
    id: 812,
    label: 1,
    score: 0.564539032166373,
    data_type: "random",
  },
  {
    id: 813,
    label: 1,
    score: 0.57487827096074,
    data_type: "random",
  },
  {
    id: 814,
    label: 1,
    score: 0.549637462404341,
    data_type: "random",
  },
  {
    id: 815,
    label: 1,
    score: 0.74834517567721,
    data_type: "random",
  },
  {
    id: 816,
    label: 1,
    score: 0.391926760066599,
    data_type: "random",
  },
  {
    id: 817,
    label: 1,
    score: 0.54953474595905,
    data_type: "random",
  },
  {
    id: 818,
    label: 1,
    score: 0.559461908729476,
    data_type: "random",
  },
  {
    id: 819,
    label: 1,
    score: 0.648140907212919,
    data_type: "random",
  },
  {
    id: 820,
    label: 1,
    score: 0.364010196997318,
    data_type: "random",
  },
  {
    id: 821,
    label: 1,
    score: 0.397389564514425,
    data_type: "random",
  },
  {
    id: 822,
    label: 1,
    score: 0.80010722209518,
    data_type: "random",
  },
  {
    id: 823,
    label: 1,
    score: 0.552158616087273,
    data_type: "random",
  },
  {
    id: 824,
    label: 1,
    score: 0.292638302610785,
    data_type: "random",
  },
  {
    id: 825,
    label: 1,
    score: 0.597279499816035,
    data_type: "random",
  },
  {
    id: 826,
    label: 1,
    score: 0.632865007921701,
    data_type: "random",
  },
  {
    id: 827,
    label: 1,
    score: 0.428100015836935,
    data_type: "random",
  },
  {
    id: 828,
    label: 1,
    score: 0.614370094860305,
    data_type: "random",
  },
  {
    id: 829,
    label: 1,
    score: 0.558955061459861,
    data_type: "random",
  },
  {
    id: 830,
    label: 1,
    score: 0.620005608681479,
    data_type: "random",
  },
  {
    id: 831,
    label: 1,
    score: 0.252644912959367,
    data_type: "random",
  },
  {
    id: 832,
    label: 1,
    score: 0.263618416360558,
    data_type: "random",
  },
  {
    id: 833,
    label: 1,
    score: 0.688282060018295,
    data_type: "random",
  },
  {
    id: 834,
    label: 1,
    score: 0.72078669099341,
    data_type: "random",
  },
  {
    id: 835,
    label: 1,
    score: 0.329928851361408,
    data_type: "random",
  },
  {
    id: 836,
    label: 1,
    score: 0.328570080662384,
    data_type: "random",
  },
  {
    id: 837,
    label: 1,
    score: 0.68271053734119,
    data_type: "random",
  },
  {
    id: 838,
    label: 1,
    score: 0.803625061390714,
    data_type: "random",
  },
  {
    id: 839,
    label: 1,
    score: 0.353079494200232,
    data_type: "random",
  },
  {
    id: 840,
    label: 1,
    score: 0.636832713269413,
    data_type: "random",
  },
  {
    id: 841,
    label: 1,
    score: 0.470983375105052,
    data_type: "random",
  },
  {
    id: 842,
    label: 1,
    score: 0.781858577736663,
    data_type: "random",
  },
  {
    id: 843,
    label: 1,
    score: 0.4046631424291,
    data_type: "random",
  },
  {
    id: 844,
    label: 1,
    score: 0.466164981647695,
    data_type: "random",
  },
  {
    id: 845,
    label: 1,
    score: 0.468812971265925,
    data_type: "random",
  },
  {
    id: 846,
    label: 1,
    score: 0.697078683750371,
    data_type: "random",
  },
  {
    id: 847,
    label: 1,
    score: 0.567586913455939,
    data_type: "random",
  },
  {
    id: 848,
    label: 1,
    score: 0.603081310350052,
    data_type: "random",
  },
  {
    id: 849,
    label: 1,
    score: 0.303760050168444,
    data_type: "random",
  },
  {
    id: 850,
    label: 1,
    score: 0.506394655329834,
    data_type: "random",
  },
  {
    id: 851,
    label: 1,
    score: 0.386448769503105,
    data_type: "random",
  },
  {
    id: 852,
    label: 1,
    score: 0.475421336274389,
    data_type: "random",
  },
  {
    id: 853,
    label: 1,
    score: 0.396185188782261,
    data_type: "random",
  },
  {
    id: 854,
    label: 1,
    score: 0.397608886770855,
    data_type: "random",
  },
  {
    id: 855,
    label: 1,
    score: 0.624919697623301,
    data_type: "random",
  },
  {
    id: 856,
    label: 1,
    score: 0.486645871454413,
    data_type: "random",
  },
  {
    id: 857,
    label: 1,
    score: 0.660514101412131,
    data_type: "random",
  },
  {
    id: 858,
    label: 1,
    score: 0.636729428146149,
    data_type: "random",
  },
  {
    id: 859,
    label: 1,
    score: 0.823921720008008,
    data_type: "random",
  },
  {
    id: 860,
    label: 1,
    score: 0.564381155379008,
    data_type: "random",
  },
  {
    id: 861,
    label: 1,
    score: 0.437027454163671,
    data_type: "random",
  },
  {
    id: 862,
    label: 1,
    score: 0.707266904384222,
    data_type: "random",
  },
  {
    id: 863,
    label: 1,
    score: 0.48500899373184,
    data_type: "random",
  },
  {
    id: 864,
    label: 1,
    score: 0.568813416187449,
    data_type: "random",
  },
  {
    id: 865,
    label: 1,
    score: 0.705520033656898,
    data_type: "random",
  },
  {
    id: 866,
    label: 1,
    score: 0.409425936271988,
    data_type: "random",
  },
  {
    id: 867,
    label: 1,
    score: 0.770079870711102,
    data_type: "random",
  },
  {
    id: 868,
    label: 1,
    score: 0.41771430931679,
    data_type: "random",
  },
  {
    id: 869,
    label: 1,
    score: 0.675455462359539,
    data_type: "random",
  },
  {
    id: 870,
    label: 1,
    score: 0.651304718038306,
    data_type: "random",
  },
  {
    id: 871,
    label: 1,
    score: 0.671632790421744,
    data_type: "random",
  },
  {
    id: 872,
    label: 1,
    score: 0.758373817117222,
    data_type: "random",
  },
  {
    id: 873,
    label: 1,
    score: 0.666481311882476,
    data_type: "random",
  },
  {
    id: 874,
    label: 1,
    score: 0.334524210658496,
    data_type: "random",
  },
  {
    id: 875,
    label: 1,
    score: 0.368067523276323,
    data_type: "random",
  },
  {
    id: 876,
    label: 1,
    score: 0.571791306479526,
    data_type: "random",
  },
  {
    id: 877,
    label: 1,
    score: 0.391677591016448,
    data_type: "random",
  },
  {
    id: 878,
    label: 1,
    score: 0.381628814812983,
    data_type: "random",
  },
  {
    id: 879,
    label: 1,
    score: 0.494479785498355,
    data_type: "random",
  },
  {
    id: 880,
    label: 1,
    score: 0.616345435999602,
    data_type: "random",
  },
  {
    id: 881,
    label: 1,
    score: 0.517676139152905,
    data_type: "random",
  },
  {
    id: 882,
    label: 1,
    score: 0.436019452988844,
    data_type: "random",
  },
  {
    id: 883,
    label: 1,
    score: 0.642833697242145,
    data_type: "random",
  },
  {
    id: 884,
    label: 1,
    score: 0.780778569333923,
    data_type: "random",
  },
  {
    id: 885,
    label: 1,
    score: 0.623115986553623,
    data_type: "random",
  },
  {
    id: 886,
    label: 1,
    score: 0.394251020555609,
    data_type: "random",
  },
  {
    id: 887,
    label: 1,
    score: 0.707473341094321,
    data_type: "random",
  },
  {
    id: 888,
    label: 1,
    score: 0.414089518776879,
    data_type: "random",
  },
  {
    id: 889,
    label: 1,
    score: 0.810428206560285,
    data_type: "random",
  },
  {
    id: 890,
    label: 1,
    score: 0.789287119971157,
    data_type: "random",
  },
  {
    id: 891,
    label: 1,
    score: 0.682768403630348,
    data_type: "random",
  },
  {
    id: 892,
    label: 1,
    score: 0.469503468755295,
    data_type: "random",
  },
  {
    id: 893,
    label: 1,
    score: 0.650377455773847,
    data_type: "random",
  },
  {
    id: 894,
    label: 1,
    score: 0.354406055309198,
    data_type: "random",
  },
  {
    id: 895,
    label: 1,
    score: 0.595520801863071,
    data_type: "random",
  },
  {
    id: 896,
    label: 1,
    score: 0.564786310205121,
    data_type: "random",
  },
  {
    id: 897,
    label: 1,
    score: 0.643055120704376,
    data_type: "random",
  },
  {
    id: 898,
    label: 1,
    score: 0.502875416710987,
    data_type: "random",
  },
  {
    id: 899,
    label: 1,
    score: 0.314388904581243,
    data_type: "random",
  },
  {
    id: 900,
    label: 1,
    score: 0.388189377054761,
    data_type: "random",
  },
  {
    id: 901,
    label: 1,
    score: 0.658955296026721,
    data_type: "random",
  },
  {
    id: 902,
    label: 1,
    score: 0.536395524285374,
    data_type: "random",
  },
  {
    id: 903,
    label: 1,
    score: 0.623871419161872,
    data_type: "random",
  },
  {
    id: 904,
    label: 1,
    score: 0.691145093585306,
    data_type: "random",
  },
  {
    id: 905,
    label: 1,
    score: 0.583057547502579,
    data_type: "random",
  },
  {
    id: 906,
    label: 1,
    score: 0.666114983669629,
    data_type: "random",
  },
  {
    id: 907,
    label: 1,
    score: 0.477642159827545,
    data_type: "random",
  },
  {
    id: 908,
    label: 1,
    score: 0.630145295322717,
    data_type: "random",
  },
  {
    id: 909,
    label: 1,
    score: 0.734888680705083,
    data_type: "random",
  },
  {
    id: 910,
    label: 1,
    score: 0.621526121458773,
    data_type: "random",
  },
  {
    id: 911,
    label: 1,
    score: 0.608127458136391,
    data_type: "random",
  },
  {
    id: 912,
    label: 1,
    score: 0.798188494373073,
    data_type: "random",
  },
  {
    id: 913,
    label: 1,
    score: 0.631221820929994,
    data_type: "random",
  },
  {
    id: 914,
    label: 1,
    score: 0.47665088812873,
    data_type: "random",
  },
  {
    id: 915,
    label: 1,
    score: 0.659813441290606,
    data_type: "random",
  },
  {
    id: 916,
    label: 1,
    score: 0.641466369907182,
    data_type: "random",
  },
  {
    id: 917,
    label: 1,
    score: 0.343743948495326,
    data_type: "random",
  },
  {
    id: 918,
    label: 1,
    score: 0.598951811376215,
    data_type: "random",
  },
  {
    id: 919,
    label: 1,
    score: 0.596255870658586,
    data_type: "random",
  },
  {
    id: 920,
    label: 1,
    score: 0.365715398489205,
    data_type: "random",
  },
  {
    id: 921,
    label: 1,
    score: 0.745455478452873,
    data_type: "random",
  },
  {
    id: 922,
    label: 1,
    score: 0.702302680668775,
    data_type: "random",
  },
  {
    id: 923,
    label: 1,
    score: 0.695725455240165,
    data_type: "random",
  },
  {
    id: 924,
    label: 1,
    score: 0.64784618754115,
    data_type: "random",
  },
  {
    id: 925,
    label: 1,
    score: 0.632562306371385,
    data_type: "random",
  },
  {
    id: 926,
    label: 1,
    score: 0.506264377326581,
    data_type: "random",
  },
  {
    id: 927,
    label: 1,
    score: 0.519752922429886,
    data_type: "random",
  },
  {
    id: 928,
    label: 1,
    score: 0.685947027734199,
    data_type: "random",
  },
  {
    id: 929,
    label: 1,
    score: 0.694297605740246,
    data_type: "random",
  },
  {
    id: 930,
    label: 1,
    score: 0.597098714007481,
    data_type: "random",
  },
  {
    id: 931,
    label: 1,
    score: 0.793007227925078,
    data_type: "random",
  },
  {
    id: 932,
    label: 1,
    score: 0.511482776741906,
    data_type: "random",
  },
  {
    id: 933,
    label: 1,
    score: 0.398030478393151,
    data_type: "random",
  },
  {
    id: 934,
    label: 1,
    score: 0.62401948622179,
    data_type: "random",
  },
  {
    id: 935,
    label: 1,
    score: 0.483104799284425,
    data_type: "random",
  },
  {
    id: 936,
    label: 1,
    score: 0.377611167052602,
    data_type: "random",
  },
  {
    id: 937,
    label: 1,
    score: 0.718227453741426,
    data_type: "random",
  },
  {
    id: 938,
    label: 1,
    score: 0.465508407001621,
    data_type: "random",
  },
  {
    id: 939,
    label: 1,
    score: 0.726783636130989,
    data_type: "random",
  },
  {
    id: 940,
    label: 1,
    score: 0.740042747089489,
    data_type: "random",
  },
  {
    id: 941,
    label: 1,
    score: 0.314974174055682,
    data_type: "random",
  },
  {
    id: 942,
    label: 1,
    score: 0.627108262242649,
    data_type: "random",
  },
  {
    id: 943,
    label: 1,
    score: 0.719820541125602,
    data_type: "random",
  },
  {
    id: 944,
    label: 1,
    score: 0.635790920945339,
    data_type: "random",
  },
  {
    id: 945,
    label: 1,
    score: 0.445986382733333,
    data_type: "random",
  },
  {
    id: 946,
    label: 1,
    score: 0.841346315471183,
    data_type: "random",
  },
  {
    id: 947,
    label: 1,
    score: 0.711822620196021,
    data_type: "random",
  },
  {
    id: 948,
    label: 1,
    score: 0.468539978974576,
    data_type: "random",
  },
  {
    id: 949,
    label: 1,
    score: 0.819918872025011,
    data_type: "random",
  },
  {
    id: 950,
    label: 1,
    score: 0.366718119518243,
    data_type: "random",
  },
  {
    id: 951,
    label: 1,
    score: 0.72135430577763,
    data_type: "random",
  },
  {
    id: 952,
    label: 1,
    score: 0.755255067231637,
    data_type: "random",
  },
  {
    id: 953,
    label: 1,
    score: 0.623707987843123,
    data_type: "random",
  },
  {
    id: 954,
    label: 1,
    score: 0.736473703599267,
    data_type: "random",
  },
  {
    id: 955,
    label: 1,
    score: 0.382389276305661,
    data_type: "random",
  },
  {
    id: 956,
    label: 1,
    score: 0.531335371640461,
    data_type: "random",
  },
  {
    id: 957,
    label: 1,
    score: 0.482840133484133,
    data_type: "random",
  },
  {
    id: 958,
    label: 1,
    score: 0.69912429864914,
    data_type: "random",
  },
  {
    id: 959,
    label: 1,
    score: 0.458890592360642,
    data_type: "random",
  },
  {
    id: 960,
    label: 1,
    score: 0.491350765308775,
    data_type: "random",
  },
  {
    id: 961,
    label: 1,
    score: 0.394337939091976,
    data_type: "random",
  },
  {
    id: 962,
    label: 1,
    score: 0.506082518989373,
    data_type: "random",
  },
  {
    id: 963,
    label: 1,
    score: 0.787028917017374,
    data_type: "random",
  },
  {
    id: 964,
    label: 1,
    score: 0.611041010646838,
    data_type: "random",
  },
  {
    id: 965,
    label: 1,
    score: 0.8204866429613,
    data_type: "random",
  },
  {
    id: 966,
    label: 1,
    score: 0.35958604975466,
    data_type: "random",
  },
  {
    id: 967,
    label: 1,
    score: 0.628573918510918,
    data_type: "random",
  },
  {
    id: 968,
    label: 1,
    score: 0.603344347842613,
    data_type: "random",
  },
  {
    id: 969,
    label: 1,
    score: 0.578909904143497,
    data_type: "random",
  },
  {
    id: 970,
    label: 1,
    score: 0.508070821923255,
    data_type: "random",
  },
  {
    id: 971,
    label: 1,
    score: 0.645178772202113,
    data_type: "random",
  },
  {
    id: 972,
    label: 1,
    score: 0.479475606496062,
    data_type: "random",
  },
  {
    id: 973,
    label: 1,
    score: 0.716359540898622,
    data_type: "random",
  },
  {
    id: 974,
    label: 1,
    score: 0.516792483567444,
    data_type: "random",
  },
  {
    id: 975,
    label: 1,
    score: 0.228819453140176,
    data_type: "random",
  },
  {
    id: 976,
    label: 1,
    score: 0.326650571130163,
    data_type: "random",
  },
  {
    id: 977,
    label: 1,
    score: 0.513826445194387,
    data_type: "random",
  },
  {
    id: 978,
    label: 1,
    score: 0.429368371286773,
    data_type: "random",
  },
  {
    id: 979,
    label: 1,
    score: 0.355543514143153,
    data_type: "random",
  },
  {
    id: 980,
    label: 1,
    score: 0.592929254978946,
    data_type: "random",
  },
  {
    id: 981,
    label: 1,
    score: 0.383840978001445,
    data_type: "random",
  },
  {
    id: 982,
    label: 1,
    score: 0.697609332420664,
    data_type: "random",
  },
  {
    id: 983,
    label: 1,
    score: 0.778774379730799,
    data_type: "random",
  },
  {
    id: 984,
    label: 1,
    score: 0.648513104533842,
    data_type: "random",
  },
  {
    id: 985,
    label: 1,
    score: 0.623072021764192,
    data_type: "random",
  },
  {
    id: 986,
    label: 1,
    score: 0.61876540653089,
    data_type: "random",
  },
  {
    id: 987,
    label: 1,
    score: 0.48813954791677,
    data_type: "random",
  },
  {
    id: 988,
    label: 1,
    score: 0.626203353205109,
    data_type: "random",
  },
  {
    id: 989,
    label: 1,
    score: 0.515041177179424,
    data_type: "random",
  },
  {
    id: 990,
    label: 1,
    score: 0.358250740973472,
    data_type: "random",
  },
  {
    id: 991,
    label: 1,
    score: 0.60197517546647,
    data_type: "random",
  },
  {
    id: 992,
    label: 1,
    score: 0.463583155115692,
    data_type: "random",
  },
  {
    id: 993,
    label: 1,
    score: 0.591692363316658,
    data_type: "random",
  },
  {
    id: 994,
    label: 1,
    score: 0.576489802837876,
    data_type: "random",
  },
  {
    id: 995,
    label: 1,
    score: 0.7252922095807,
    data_type: "random",
  },
  {
    id: 996,
    label: 1,
    score: 0.620719916162826,
    data_type: "random",
  },
  {
    id: 997,
    label: 1,
    score: 0.632622062149214,
    data_type: "random",
  },
  {
    id: 998,
    label: 1,
    score: 0.33073133305065,
    data_type: "random",
  },
  {
    id: 999,
    label: 1,
    score: 0.673665515165767,
    data_type: "random",
  },
  {
    id: 1000,
    label: 1,
    score: 0.654013117478183,
    data_type: "random",
  },
  {
    id: 1001,
    label: 1,
    score: 0.697082749436779,
    data_type: "single_mom_default",
  },
  {
    id: 1002,
    label: 0,
    score: 0.640378408813731,
    data_type: "migrant_man_default",
  },
]
